import {ChartOptions} from 'chart.js';

import {greenColors} from '../../../../../../../layouts/theme/designSystem';

export const getBarGraphOptions = (title: string, isPdf?: boolean): ChartOptions<'bar'> => {
  const baseOptions: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        text: title,
        display: true,
        color: greenColors[700],
        font: {
          size: isPdf ? 14 : 20,
        },
        padding: 20,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        color: 'white',
        anchor: 'center',
        align: 'center',
        formatter: (value: any) => {
          const rounded = Math.floor(value);
          return rounded < 5 ? '' : `${rounded}%`;
        },
        font: {
          weight: 'bold',
          size: isPdf ? 10 : 12,
        },
        offset: 10,
      },
    },
    layout: {
      padding: {
        bottom: -20,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: greenColors[700],
        },
        stacked: true,
      },
      y: {
        min: 0,
        max: 100,
        grid: {
          color: greenColors[700],
          drawTicks: false,
        },
        ticks: {
          color: greenColors[700],
        },
        stacked: true,
      },
    },
  };

  return baseOptions;
};
